export default __webpack_public_path__ + "static/media/3_PRESTIGIO_NUVOLATO-120x278_265.836568d6.jpg";